import React from "react";
import { useTranslation } from "react-i18next";

import { useErrorToast, useShowToast } from "adminComponents/utils/toast";
import { useCreateGuest } from "links/lib/features/auth";
import { SignInModal } from "sessionComponents/organisms/SignInModal";

const SignInOrGuestModal: React.FC = () => {
  const { t } = useTranslation("session", { useSuspense: false });
  const showToast = useShowToast();
  const createGuest = useCreateGuest({
    // todo translate
    onSuccess: () => showToast(t("signInModal.successToast")),
  });

  const createGuestUser = (opts: {
    skinTone: string;
    hairColor: string;
    hairStyleAvatarItemId: string;
  }) => {
    createGuest.mutate({
      hair_color_hex_code: opts.hairColor,
      skin_tone_hex_code: opts.skinTone,
      hair_style_avatar_item_id: opts.hairStyleAvatarItemId,
    });
  };

  useErrorToast(createGuest.error);

  return (
    <SignInModal
      isOpen={true}
      onGuestCreate={createGuestUser}
      isGuestCreatePending={createGuest.isLoading}
      signInLinkTo="/sign-in"
    />
  );
};

export default SignInOrGuestModal;
